import { useStyles } from 'components/childRegister/Editor/Obligation/Obligation.styles';
import { ObligationProps } from 'components/childRegister/Editor/Obligation/Obligation.types';
import { ExemptionsContainer } from 'components/childRegister/Editor/Obligation/parts/Exemptions/ExemptionsContainer';
import { ManualEntriesContainer } from 'components/childRegister/Editor/Obligation/parts/ManualEntries/ManualEntriesContainer';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import React, { FC, ComponentType } from 'react';
import Box from '@mui/material/Box';
import { ReportsContainer } from './parts/Reports/ReportsContainer';
import { useLocation, useParams } from 'react-router-dom';
import { connect } from 'formik';
import { ChildRegisterFormValues } from 'components/childRegister/Editor/General/General.types';

export const Obligation: ComponentType<ObligationProps> = connect<ObligationProps, ChildRegisterFormValues>((props) => {
  const classes = useStyles();
  const location = useLocation();
  const { id: childIdFromRoute } = useParams<{ id: string }>();

  const childId = props.childId || childIdFromRoute;

  return (
    <Paper innerSpacing={[4, 2, 2]} square={true} className={classes.container}>
      <Box marginBottom={4}>
        <ExemptionsContainer />
      </Box>
      <ManualEntriesContainer initial={props.initial} loading={props.loading} form={props.formik} />
      <ReportsContainer childId={childId} />
    </Paper>
  );
});
